import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Uses localStorage
import authReducer from '../slice/authSlice';
import userReducer from '../slice/usersSlice';
import  chatReducer from '../slice/chatSlice'
import threadReducer from '../slice/threadSlice';
 import taskSchedulerReducer from '../slice/taskSchedulerSlice';
import taskReducer from "../slice/taskSlice";
import subtaskReducer from "../slice/subtaskSlice";
import notificationReducer  from "../slice/notficationSlice";
import uiReducer   from '../slice/uiSlice'
import ticketReducer from "../slice/ticketSlice";  // adjust path if needed
import hrReducer from "../slice/hrSlice";
import meetingReducer from "../slice/meetingSlice";
import documentReducer from '../slice/documentSlice'
import pushReducer from '../slice/pushSlice'
import clientReducer from '../slice/clientSlice'
import domainReducer from '../slice/domainSlice'
import marketReducer from '../slice/marketSlice'
import quotationAdjustmentsReducer from '../slice/quotationAdjustmentsSlice'
import airVendorReducer from '../slice/airVendorSlice'
import seaVendorReducer from '../slice/seaVendorSlice'
import roadVendorReducer from '../slice/roadVendorSlice'
import trainingVideoReducer from '../slice/trainingVideoSlice'
import trainingCourseReducer from '../slice/trainingCourseSlice'
import achievementReducer from '../slice/achievementSlice'
import mistakeReducer from '../slice/mistakeSlice'
import profileDocumentReducer from '../slice/profileDocumentSlice'
import ordersReducer from '../slice/ordersSlice'
import companyReducer from '../slice/companySlice'
import targetCompanyReducer from '../slice/targetCompanySlice'
import vendorReducer from '../slice/vendorSlice'
import vendorMaterialSpecsReducer from '../slice/vendorMaterialSpecsSlice'
import deletedVendorReducer from '../slice/deletedVendorSlice'
import vendorDetailsReducer from '../slice/vendorDetailsSlice'
import followUpReducer from '../FollowUp/store/followUpSlice'
import followUpBiddingReducer from '../FollowUp/store/followUpBiddingSlice'
import emailAppReducer from '../slice/emailAppSlice'
import emailTemplatesReducer from '../slice/emailTemplatesSlice'
import emailContactsReducer from '../slice/emailContactsSlice'
import emailAudienceReducer from '../slice/emailAudienceSlice'
import emailSavedSegmentsReducer from '../slice/emailSavedSegmentsSlice'
import emailCampaignsReducer from '../slice/emailCampaignsSlice'
import emailSubCampaignsReducer from '../slice/emailSubCampaignsSlice'
import whatsappRecordsReducer from '../slice/whatsappRecordsSlice'
import whatsappTemplatesReducer from '../slice/whatsappTemplatesSlice'
import whatsappCampaignsReducer from '../slice/whatsappCampaignsSlice'
import whatsappContactsReducer from '../slice/whatsappContactsSlice'
import whatsappInboxReducer from '../slice/whatsappInboxSlice'
import notInterestedReducer from '../slice/notInterestedSlice'
import leadReducer from '../slice/leadSlice'
import inquiryReducer from '../slice/inquirySlice'
import sccReducer from '../SalesCommandCenter/store/sccSlice'

const persistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user', 'token'], // Only persist authentication state
};

const marketPersistConfig = {
  key: 'market',
  storage,
  whitelist: ['activeMarket', 'allowed'],
};

// Create persisted reducer for authentication
const persistedAuthReducer = persistReducer(persistConfig, authReducer);
const persistedMarketReducer = persistReducer(marketPersistConfig, marketReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    users: userReducer,
    task:taskReducer,
    subtasks: subtaskReducer,
    notfication:notificationReducer,
     taskScheduler: taskSchedulerReducer,
    chat: chatReducer,
    thread: threadReducer,
     ui: uiReducer,
       tickets: ticketReducer,
    hr: hrReducer,
    documents: documentReducer,
    meetings: meetingReducer,
    push: pushReducer,
    clients: clientReducer,
    domains: domainReducer,
    market: persistedMarketReducer,
    quotationAdjustments: quotationAdjustmentsReducer,
    airVendors: airVendorReducer,
    seaVendors: seaVendorReducer,
    roadVendors: roadVendorReducer,
    trainingVideos: trainingVideoReducer,
    trainingCourses: trainingCourseReducer,
    achievements: achievementReducer,
    mistakes: mistakeReducer,
    profileDocuments: profileDocumentReducer,
    orders: ordersReducer,
    company: companyReducer,
    targetCompany: targetCompanyReducer,
    vendors: vendorReducer,
    vendorMaterialSpecs: vendorMaterialSpecsReducer,
    deletedVendors: deletedVendorReducer,
    vendorDetails: vendorDetailsReducer,
    followUp: followUpReducer,
    followUpBidding: followUpBiddingReducer,
    emailApp: emailAppReducer,
    emailTemplates: emailTemplatesReducer,
    emailContacts: emailContactsReducer,
    emailAudience: emailAudienceReducer,
    emailSavedSegments: emailSavedSegmentsReducer,
    emailCampaigns: emailCampaignsReducer,
    emailSubCampaigns: emailSubCampaignsReducer,
    whatsappRecords: whatsappRecordsReducer,
    whatsappTemplates: whatsappTemplatesReducer,
    whatsappCampaigns: whatsappCampaignsReducer,
    whatsappContacts: whatsappContactsReducer,
    whatsappInbox: whatsappInboxReducer,
    notInterested: notInterestedReducer,
    leads: leadReducer,
    inquiry: inquiryReducer,
    scc: sccReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Required for redux-persist
    }),
});

export const persistor = persistStore(store);

export default store;
